// package: profile
// file: apigateway/profile/rating.proto

import * as apigateway_profile_rating_pb from "../../apigateway/profile/rating_pb";
export class RatingService {
  static serviceName = "profile.RatingService";
}
export namespace RatingService {
  export class GetRatingSummary {
    static readonly methodName = "GetRatingSummary";
    static readonly service = RatingService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_rating_pb.GetRatingSummaryRequest;
    static readonly responseType = apigateway_profile_rating_pb.RatingSummaryReply;
  }
  export class GetMyRatingSummary {
    static readonly methodName = "GetMyRatingSummary";
    static readonly service = RatingService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_rating_pb.GetMyRatingSummaryRequest;
    static readonly responseType = apigateway_profile_rating_pb.RatingSummaryReply;
  }
  export class GetRatingComments {
    static readonly methodName = "GetRatingComments";
    static readonly service = RatingService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_rating_pb.GetRatingCommentsRequest;
    static readonly responseType = apigateway_profile_rating_pb.RatingCommentsReply;
  }
  export class GetMyRatingComments {
    static readonly methodName = "GetMyRatingComments";
    static readonly service = RatingService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_rating_pb.GetMyRatingCommentsRequest;
    static readonly responseType = apigateway_profile_rating_pb.RatingCommentsReply;
  }
}
